module.exports = __webpack_public_path__ + "media/application/images/disclaimer-bg-1feb25cf4c659303788b2d9e67f8f40f.jpg";